import React from "react";

function PopulariIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 0C26.6274 0 32 5.37258 32 12V20C32 26.6274 26.6274 32 20 32H12C5.37258 32 0 26.6274 0 20V12C0 5.37258 5.37258 0 12 0H20Z"
        fill="white"
      />
      <path
        d="M20 0C26.6274 0 32 5.37258 32 12V20C32 26.6274 26.6274 32 20 32H12C5.37258 32 0 26.6274 0 20V12C0 5.37258 5.37258 0 12 0H20Z"
        stroke="#667085"
      />
      <path
        d="M15.925 6.22849C15.9688 6.13995 16.0365 6.06542 16.1204 6.01331C16.2044 5.96121 16.3012 5.93359 16.4 5.93359C16.4988 5.93359 16.5956 5.96121 16.6795 6.01331C16.7635 6.06542 16.8312 6.13995 16.875 6.22849L19.185 10.9075C19.3372 11.2155 19.5618 11.4819 19.8396 11.6839C20.1174 11.886 20.4401 12.0176 20.78 12.0675L25.946 12.8235C26.0439 12.8377 26.1358 12.879 26.2115 12.9427C26.2871 13.0064 26.3434 13.09 26.374 13.1841C26.4046 13.2782 26.4083 13.3789 26.3846 13.4749C26.3609 13.571 26.3108 13.6584 26.24 13.7275L22.504 17.3655C22.2576 17.6056 22.0733 17.902 21.9668 18.2291C21.8604 18.5563 21.8351 18.9044 21.893 19.2435L22.775 24.3835C22.7923 24.4813 22.7817 24.5821 22.7445 24.6742C22.7073 24.7663 22.6449 24.8461 22.5645 24.9045C22.4842 24.9629 22.389 24.9975 22.2899 25.0044C22.1907 25.0113 22.0917 24.9902 22.004 24.9435L17.386 22.5155C17.0817 22.3557 16.7432 22.2722 16.3995 22.2722C16.0558 22.2722 15.7173 22.3557 15.413 22.5155L10.796 24.9435C10.7083 24.9899 10.6094 25.0108 10.5104 25.0037C10.4115 24.9967 10.3165 24.962 10.2363 24.9037C10.1561 24.8454 10.0938 24.7657 10.0566 24.6737C10.0195 24.5817 10.0089 24.4812 10.026 24.3835L10.907 19.2445C10.9652 18.9052 10.94 18.5569 10.8335 18.2295C10.7271 17.9022 10.5426 17.6056 10.296 17.3655L6.55999 13.7285C6.48859 13.6595 6.43799 13.5719 6.41396 13.4756C6.38992 13.3792 6.39343 13.2781 6.42407 13.1837C6.45471 13.0893 6.51126 13.0053 6.58727 12.9415C6.66328 12.8776 6.7557 12.8364 6.85399 12.8225L12.019 12.0675C12.3592 12.018 12.6824 11.8865 12.9606 11.6845C13.2388 11.4824 13.4637 11.2158 13.616 10.9075L15.925 6.22849Z"
        stroke="#4072C8"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default PopulariIcon;
